import { render, staticRenderFns } from "./PedidoEncaminhado.vue?vue&type=template&id=6ff11bac&"
import script from "./PedidoEncaminhado.vue?vue&type=script&lang=js&"
export * from "./PedidoEncaminhado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports